<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
  >
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-card class="pa-5">
     
        <v-card-title class="justify-center">
          {{ $t("searchForItemsToShare") }}
        </v-card-title>

        <v-card-text class="text-center">
          {{ $t("searchForItemsToShareText") }}
        </v-card-text>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            @keyup.enter="submitDialogBtn()"
            @submit.prevent
          >
            <v-autocomplete
              :key="'share-items'"
              v-model="selectedItems"
              :menu-props="{
                rounded: 'xxl',
                zIndex: '9999 !important',
              }"
              item-text="searchTerm"
              item-value="id"
              hide-selected
              multiple
              rounded
              clearable
              solo
              no-filter
              chips
              autofocus
              return-object
              :search-input.sync="searchKeyword"
              :loading="loadingEntities"
              @click="searchKeyword = ''"
              :items="items"
              append-icon="mdi-magnify"
              background-color="#fff"
              data-testid="entity-select"
              class="expanding-search text-body-2 mt-3"
              :placeholder="$t('search')"
              @blur="closeSearch"
              @change="change"
            >
              <template v-slot:selection="data">
                <v-chip
                    v-bind="data.attrs"
                    close
                    data-testid="user-chip"
                    :color="data.item.type == 'hubs' ? 'accent' : data.item.type == 'tags' ? 'primary' : 'secondary'"
                    @click:close="removeItem(data.item)"
                    >
                    <v-img
                        v-if="data.item.type == 'hubs' || data.item.type == 'activities'"
                        :src="
                            data.item.attributes.image
                            ? data.item.attributes.image
                            : require('../assets/cover-activity.jpg')
                        "
                        class="ma-0 mx-1 rounded-lg"
                        :class="
                            data.item.type == 'activities' ? 'activity' : 'hub'
                        "
                        width="25"
                        height="20"
                        />
                    
                            
                    <span class="text-truncate" >{{ data.item.type == 'tags' ? data.item.attributes.name : data.item.attributes.title }}</span>
                </v-chip>
              </template>

              <template v-slot:item="data" data-testid="suggested-item">
                <template >
                  <v-row
                    no-gutters
                    v-if="
                      data.item.type == 'hubs' || data.item.type == 'activities'
                    "
                    align="center"
                  >
                    <v-col cols="2">
                      <v-img
                        :src="
                          data.item.attributes.image
                            ? data.item.attributes.image
                            : require('../assets/cover-activity.jpg')
                        "
                        class="ma-0 mx-2 rounded-lg"
                        :class="
                          data.item.type == 'activities' ? 'activity' : 'hub'
                        "
                        width="50"
                        height="40"
                      />
                    </v-col>
                    <v-col cols="10">
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-no-wrap text-truncate px-2"
                          style="width: 280px"
                        >
                          <v-chip
                            v-if="data.item.type == 'hubs'"
                            small
                            color="accent"
                          >
                            <span class="text-uppercase">{{ $t("hub") }}</span>
                          </v-chip>
                          {{ data.item.attributes.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-col>
                  </v-row>
                  <v-row
                    no-gutters
                    v-if="data.item.type == 'tags'"
                    align="center"
                  >
                    <v-col cols="2"> </v-col>
                    <v-col cols="10">
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-no-wrap text-truncate px-2"
                          style="width: 280px"
                        >
                          <v-chip small color="accent">
                            <span class="text-uppercase">Tag</span>
                          </v-chip>
                          {{ data.item.attributes.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-col>
                  </v-row>
                </template>
              </template>
              <template v-slot:no-data>
                <p class="mx-5 mt-4">
                  {{ $t("noDataText") }}
                </p>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card-text>
     
        <v-card-actions> <v-spacer />
            <v-btn
            ref="cancel"
            data-testid="cancel-button"
            color="darktext"
            min-width="100"
            dark
            elevation="0"
            class="rounded-xxl text-none px-4 cancel"
            :disabled="loading"
            @click="show = false"
            >
            {{ $t("cancel") }}
            </v-btn>
            <v-btn
            ref="submit"
            data-testid="submit-button"
            type="submit"
            color="accent"
            min-width="100"
            dark
            elevation="0"
            class="rounded-xxl text-none px-4 submit create-template"
            :loading="loading"
            :disabled="loading || !selectedItems"
            @click="submitDialogBtn()"
            >
            {{ $t("share") }}
            </v-btn>
        </v-card-actions>
        </v-card>
  </v-dialog>
</template>
<script>
import i18n from "../plugins/i18n";
import AlertMessages from "./AlertMessages";

import { searchActivitiesIsBooster, getTags } from "../api/activityApi";
import { searchHubsIsBooster } from "../api/hubApi";
import _ from "lodash";

export default {
  components: {
    AlertMessages,
  },
  props: {
    visible: Boolean,
    selectedRole: {
      type: String,
      default: "participant",
    },
    page: {
      type: String,
      default: "",
    },
    viewedUser: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      valid: true,
      alertMsg: "",
      alertType: "",
      alertValue: false,
      loading: false,
      spaceId: window.$cookies.get("space_id"),
      loadingEntities: false,
      selectedItems: [],
      searchKeyword: null,
      entries: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    productPlan() {
        return this.$store.state.productPlan;
    },

    items () {
        return this.entries.map(entry => {
            if (entry.type == 'hubs' || entry.type == 'activities') {
                const searchTerm = entry.attributes.title
                return Object.assign({}, entry, { searchTerm })
            } else if (entry.type == 'tags') {
                const searchTerm = entry.attributes.name
                return Object.assign({}, entry, { searchTerm })
            }
        })
    },
  },
  watch: {
    searchKeyword(val) {
      if (val == null || val == "") {
        return;
      }
      let searchkey = val.trim();
      if (searchkey.length < 2) return;
      this.searchActivitiesAndHubs(searchkey);
    }
  },
  methods: {

    change(){
        this.searchKeyword = ''
    },
    removeItem(item) {
        this.selectedItems.splice(this.selectedItems.indexOf(item), 1)
        this.selectedItems = [...this.selectedItems]
    },
    closeSearch(){
        this.searchKeyword = ''
        this.entries = this.selectedItems.slice();
    },

    searchActivitiesAndHubs: _.debounce(async function (keyword) {
      var searchActivities = [];
      var searchHubs = [];
      var searchTags = [];
      if (keyword && keyword.trim().length >= 2) {
        this.loadingEntities = true;

        try {

            try {
                const response = await getTags(this.spaceId, keyword);
                if (response) {
                if (response.status == 200) {
                    searchTags = response.data.data;
                }
                }
            } catch (e) {
                if (e.response) {
                this.error = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
                }
            }

            try {
                const response = await searchActivitiesIsBooster(
                this.spaceId,
                keyword
                );
                if (response) {
                if (response.status == 200) {
                    searchActivities = response.data.data;
                }
                }
            } catch (e) {
                if (e.response) {
                this.error = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
                }
            }
            if (
                this.productPlan.attributes &&
                this.productPlan.attributes.name != "Free"
            ) {
                try {
                const response = await searchHubsIsBooster(this.spaceId, keyword);
                if (response) {
                    if (response.status == 200) {
                    searchHubs = response.data.data;
                    }
                }
                } catch (e) {
                if (e.response) {
                    this.error = true;
                    this.alertType = "error";
                    this.alertMsg = i18n.t("serverError");
                    this.alertValue = true;
                }
                }
            }

         

            Array.prototype.push.apply(searchActivities, searchHubs);
            Array.prototype.push.apply(searchActivities, searchTags);
            searchActivities.sort(function (a, b) {
                return a.sort_term > b.sort_term
                ? 1
                : b.sort_term > a.sort_term
                ? -1
                : 0;
            });
            this.entries = searchActivities;
        } catch (e) {
          if (e.response) {
            this.error = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
            this.alertValue = true;
          }
        } finally {
          this.loadingEntities = false;
        }
      }
    }, 500),

    async submitDialogBtn() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.$emit("proceedSubmit", this.selectedItems);
        this.loading = true;
      }
    },
  },
};
</script>
